import { createRoute } from '@tanstack/react-router'

import { rootRoute } from '@/routes/root'

export const averageFxRateRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/average-fx-rate',
}).lazy(() => import('./view/averageFxRate').then((d) => d.Route))
